export const EXTERNAL_USER = 'external';
export const DISTRIBUTOR_USER = 'distributor';